import type { IssueParent } from '../../../../model/issue-parent/types.tsx';

export const ISSUE_PARENTS_CREATE_SET =
	'state.actions.issue-parents.create.ISSUE_PARENTS_CREATE_SET' as const;

type IssueParentsCreateSetPayload = {
	issueParents: IssueParent[];
};

export type IssueParentsCreateSetAction = {
	type: typeof ISSUE_PARENTS_CREATE_SET;
	payload: IssueParentsCreateSetPayload;
};

export const issueParentsCreateSet = (
	payload: IssueParentsCreateSetPayload,
): IssueParentsCreateSetAction => ({
	type: ISSUE_PARENTS_CREATE_SET,
	payload,
});

export type Action = IssueParentsCreateSetAction;
